module.exports = __webpack_public_path__ + "static/media/Readeo_Logo_Dark.9e5bd8ec.svg";